export default {
  metadata: {
    version: '1.0.0',
    id: 'search-box-1.0.0',
    name: 'JDSSearchBox',
    description:
      'The search pattern allows users to quickly find relevant content by typing a querry',
    usage:
      'The Search function is triggered as soon as the user focuses in the search field or hits on the search icon. Initially he can see a list of recent searches and quick links but as soon as he starts typing he would see suggestions relevant with his querry.'
  },
  hierarchy: {
    container: [
      {
        'prefix-container': ['prefix-icon']
      },
      'input',
      {
        'suffix-container': ['suffix-icon']
      }
    ]
  },
  base: {
    container: {
      opacity: '{s_10}',
      'background-color': '{s_0}',
      'flex-direction': '{s_1}',
      'justify-content': '{s_2}',
      'align-items': '{s_3}',
      'padding-right': '{s_4}',
      'padding-left': '{s_5}',
      width: '{s_6}',
      height: '{s_7}',
      'border-radius': '{s_8}',
      gap: '{s_9}',
      behavior: {
        focus: {
          'border-color': '{s_11}',
          'border-width': '{s_12}'
        },
        active: {
          'background-color': '{s_13}'
        }
      }
    },
    input: {
      type: 'search',
      'text-align': '{s_14}',
      'placeholder-color': '{s_15}',
      'placeholder-font-family': '{s_16}',
      'placeholder-font-size': '{s_17}',
      'placeholder-line-height': '{s_18}',
      'placeholder-letter-spacing': '{s_19}',
      'placeholder-font-weight': '{s_20}',
      'input-color': '{s_21}',
      'input-font-family': '{s_22}',
      'input-font-size': '{s_23}',
      'input-line-height': '{s_24}',
      'input-letter-spacing': '{s_25}',
      'input-font-weight': '{s_26}',
      'cursor-color': '{s_27}',
      width: '{size.max}',
      disabled: false,
      flex: 1,
      behavior: {
        hover: {
          'placeholder-color': '{s_28}'
        },
        focus: {
          'placeholder-color': '{s_29}'
        },
        active: {
          'placeholder-color': '{s_30}'
        }
      }
    },
    'prefix-container': {
      'flex-direction': '{s_31}',
      'justify-content': '{s_32}',
      'align-items': '{s_33}'
    },
    'prefix-icon': {
      size: '{s_34}',
      color: '{s_35}',
      behavior: {
        hover: {
          color: '{s_36}'
        },
        focus: {
          color: '{s_37}'
        },
        active: {
          color: '{s_38}'
        }
      }
    },
    'suffix-container': {
      'flex-direction': '{s_39}',
      'justify-content': '{s_40}',
      'align-items': '{s_41}'
    },
    'suffix-icon': {
      size: '{s_42}',
      color: '{s_43}',
      behavior: {
        hover: {
          color: '{s_44}'
        },
        focus: {
          color: '{s_45}'
        },
        active: {
          color: '{s_46}'
        }
      }
    }
  },
  variant: {
    kind: {
      header: {
        container: {
          'background-color': '{s_47}',
          behavior: {
            focus: {
              'border-color': '{s_48}',
              'border-width': 4
            },
            active: {
              'background-color': '{s_49}'
            }
          }
        },
        'prefix-icon': {
          color: '{s_50}',
          behavior: {
            hover: {
              color: '{s_51}'
            },
            active: {
              color: '{s_52}'
            }
          }
        },
        'suffix-icon': {
          color: '{s_53}',
          behavior: {
            hover: {
              color: '{s_54}'
            },
            active: {
              color: '{s_55}'
            }
          }
        },
        input: {
          'input-color': '{s_56}',
          'placeholder-color': '{s_57}',
          'cursor-color': '{s_58}',
          behavior: {
            hover: {
              'placeholder-color': '{s_59}'
            }
          }
        }
      },
      light_background: {
        container: {
          'background-color': '{s_60}',
          'border-color': '{s_61}',
          'border-width': '{s_65}',
          behavior: {
            hover: {
              'background-color': '{s_60}',
              'border-color': '{s_62}'
            },
            focus: {
              'background-color': '{s_60}',
              'border-color': '{s_63}',
              'border-width': '{s_66}'
            },
            active: {
              'background-color': '{s_60}',
              'border-color': '{s_64}'
            }
          }
        },
        input: {
          'input-color': '{s_67}',
          'cursor-color': '{s_68}',
          behavior: {
            active: {
              'placeholder-color': '{s_69}'
            }
          }
        },
        'prefix-icon': {
          color: '{s_70}',
          behavior: {
            hover: {
              color: '{s_71}'
            },
            focus: {
              color: '{s_72}'
            },
            active: {
              color: '{s_73}'
            }
          }
        },
        'suffix-icon': {
          color: '{s_74}',
          behavior: {
            active: {
              color: '{s_75}'
            }
          }
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{s_76}'
        },
        'prefix-container': {
          disabled: true
        },
        'suffix-container': {
          disabled: true
        },
        input: {
          disabled: true
        }
      }
    },
    _isValueEmpty: {
      false: {
        'suffix-icon': {
          color: '{s_77}'
        }
      }
    },
    _inputFocus: {
      true: {
        input: {
          'placeholder-color': '{s_79}'
        }
      }
    }
  },
  combination: [
    {
      header: {
        false: {
          'suffix-icon': {
            color: '{s_78}'
          }
        }
      },
      light_background: {
        false: {
          'suffix-icon': {
            color: '{s_80}'
          }
        }
      }
    },
    {
      light_background: {
        true: {
          container: {
            'border-color': '{s_81}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', '_isValueEmpty'],
    ['kind', '_inputFocus']
  ],
  api: {
    config: {
      kind: {
        values: ['normal', 'header', 'light_background'],
        doc_description:
          'It determines if SearchBox is to be used on header or normal background.'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable SearchBox.'
      },
      _isValueEmpty: {
        values: [true, false]
      },
      _inputFocus: {
        values: [false, true]
      }
    },
    data: {
      input: {
        value: {
          type: 'string',
          name: 'value',
          doc_description: 'It takes user input for text to be searched.'
        },
        name: {
          type: 'string',
          name: 'name',
          doc_description: 'It displays name of search box.'
        },
        placeholder: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays placeholder text of search box.'
        },
        focusRequester: {
          type: 'focusRequester',
          name: 'focusRequester',
          platform: 'android'
        },
        imeAction: {
          type: 'imeAction',
          name: 'imeAction',
          platform: 'android'
        },
        'max-length': {
          type: 'number',
          name: 'maxLength'
        }
      },
      'prefix-icon': {
        value: {
          type: 'icon',
          name: 'prefix',
          function: true,
          doc_description: 'It can be used to pass icon as prefix.'
        }
      },
      'suffix-icon': {
        value: {
          type: 'icon',
          name: 'suffix',
          doc_description:
            'It can be used to display icon on the right of search box.'
        }
      },
      container: {
        '_prefix.showBack': {
          type: 'boolean',
          name: 'showBack'
        }
      }
    },
    events: {
      input: {
        onFocus: 'onFocus',
        onBlur: 'onBlur',
        onChange: 'onChange',
        onSubmit: 'onSubmit',
        onKeyup: {
          name: 'onKeyup',
          platform: 'web'
        },
        onKeydown: {
          name: 'onKeydown',
          platform: 'web'
        }
      },
      'prefix-container': {
        onClick: 'onBack'
      },
      'suffix-container': {
        onClick: 'onSuffixClick'
      }
    },
    a11y: {
      'prefix-icon': {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'prefixAriaLabel'
          }
        }
      },
      'suffix-icon': {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'suffixAriaLabel'
          }
        }
      },
      container: {
        properties: {
          role: {
            value: 'search'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          }
        }
      },
      input: {
        name: 'input',
        properties: {
          role: {
            value: 'searchbox'
          }
        }
      }
    }
  }
};
